import { DecimalFormatOptions, IntegerFormatOptions } from 'interfaces-lib';
import { Condition, NoFieldCondition } from './condition';

export enum StringFormatSubstring {
  NONE = 'NONE',
  START = 'START',
  END = 'END',
  RANGE = 'RANGE',
}
export enum StringFormatCapitalisation {
  NONE = 'NONE',
  ALL_UPPER = 'ALL_UPPER',
  ALL_LOWER = 'ALL_LOWER',
  CAP_ALL = 'CAP_ALL',
  CAP_FIRST = 'CAP_FIRST',
  UNCAP_FIRST = 'UNCAP_FIRST',
}

export type StringFormatOptions = {
  renderHtml: boolean;
  removeHtmlTags: boolean;
  substringType: StringFormatSubstring;
  substringFromStart: number;
  substringFromEnd: number;
  substringRangeStart: number;
  substringRangeEnd: number;
  capitalisation: StringFormatCapitalisation;
};
export type DateFormatOptions = { dateFormat: string; language: string };

export enum ImageFieldType {
  URL = 'image-url',
  ENTITY_FIELD = 'image-entity-field',
  SCRIPT_FIELD = 'image-script-field',
  FILE_TYPE = 'image-filetype',
}
export type ImageFieldOptions = {
  type: ImageFieldType;
  value: string;
  functionId?: string;
};
export type AiAssistFieldOptions = {
  type: string;
  functionId?: string;
  corpId: string;
  promptId: string;
};

export enum SortDirn {
  DSC = -1,
  NONE = 0,
  ASC = +1,
}
export type SortOption = {
  fieldPath: string;
  dirn: SortDirn;
  childFieldPath?: string;
};

export type FieldConfig = {
  dateFormatOptions?: DateFormatOptions;
  integerFormat?: IntegerFormatOptions;
  decimalFormat?: DecimalFormatOptions;
  conditions?: Condition[] | NoFieldCondition;
  sortOption?: SortOption;
  limit?: number;
  stringFormat?: StringFormatOptions;
  useDisplayValue?: boolean; // in BH there is a value -> "display value" mapping - by default we use value
  defaultEmptyValue?: string;
};
